module.exports = {"component":"textarea","status":"prod","display-name":"Textareas","SLDS-component-path":"/components/forms#flavor-textarea","url-slug":"textareas"}


//////////////////
// WEBPACK FOOTER
// ./components/textarea/docs.json
// module id = 318
// module chunks = 0